import { ChangeDetectionStrategy, Component, output } from '@angular/core'

@Component({
  selector: 'app-away-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="away-dialog-overlay" (click)="close.emit(false)">
      <div class="away-dialog" (click)="$event.stopPropagation()">
        <div class="away-dialog__title">Enjoy your break!</div>
        <div class="away-dialog__body">You are currently in 'Away' mode</div>
        <button
          class="away-dialog__btn away-dialog__btn--primary"
          (click)="close.emit(false)"
        >
          Turn off 'Away' mode
        </button>
        <button
          class="away-dialog__btn away-dialog__btn--outline"
          (click)="close.emit(true)"
        >
          Continue in 'Away' mode
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .away-dialog-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
      }
      .away-dialog {
        background: var(--lilara-surface-floating, #fff);
        border-radius: var(--lilara-radius-m, 8px);
        box-shadow: var(
          --lilara-shadow-level-3,
          0 4px 24px rgba(0, 0, 0, 0.15)
        );
        padding: var(--lilara-spacing-xl, 32px) 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--lilara-spacing-xs, 4px);
      }
      .away-dialog__title {
        font-size: var(--lilara-font-size-xl, 20px);
        font-weight: var(--lilara-font-weight-bold, 700);
        color: var(--lilara-text-contrast, #1a1a1a);
      }
      .away-dialog__body {
        font-size: var(--lilara-font-size-s, 14px);
        color: var(--lilara-text-base, #555);
        margin-bottom: var(--lilara-spacing-sm, 12px);
      }
      .away-dialog__btn {
        cursor: pointer;
        border: none;
        border-radius: var(--lilara-button-radius-medium, 6px);
        padding: var(--lilara-spacing-xs, 8px) var(--lilara-spacing-ml, 16px);
        font-size: var(--lilara-font-size-s, 14px);
        font-weight: var(--lilara-font-weight-medium, 500);
        transition: background-color 0.15s ease;
      }
      .away-dialog__btn--primary {
        background: var(--lilara-primary-500, #6e49ff);
        color: #fff;
      }
      .away-dialog__btn--primary:hover {
        background: var(--lilara-primary-600, #5b3ce0);
      }
      .away-dialog__btn--outline {
        background: transparent;
        border: 1px solid var(--lilara-primary-500, #6e49ff);
        color: var(--lilara-primary-500, #6e49ff);
      }
      .away-dialog__btn--outline:hover {
        background: var(--lilara-primary-25, #f5f0ff);
      }
    `,
  ],
})
export class AwayDialogComponent {
  readonly close = output<boolean>()
}
